import { CredentialsModel } from '@/components/login/_domain/models';
import { ServiceRequestBase } from '@/app-modules/service-request';

class LoginRequest extends ServiceRequestBase<CredentialsModel> {
  constructor(item: CredentialsModel) {
    super(item);
  }

  public isActiveDirectoryLoginRequest(): boolean {
    const adAuthRegEx = /^[^ \/\\\[\:;\|=,\+\*\?<>\]"][^\/\\\[\:;\|=,\+\*\?<>\]"]*\.[^\/\\\[\:;\|=,\+\*\?<>\]"]+$/ig;
    if (this.payload !== null && this.payload.allowActiveDirectoryLoginAttempts) {
      return adAuthRegEx.test(this.payload.username);
    }
    return false;
  }

  public correctLoginRequestCredentialsIfLoginWithEmailAttempted(): void {
    const adAuthUsername = this.extractActiveDirectoryUsernameIfLoginWithEmailAttempted();
    if (adAuthUsername) {
      this.payload.username = adAuthUsername;
    }
  }

  private extractActiveDirectoryUsernameIfLoginWithEmailAttempted(): string {
    const emailRegEx = /^([a-z0-9!#$%&'*+\/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+\/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/gi;
    if (this.payload !== null) {
      const matches = emailRegEx.exec(this.payload.username);
      if (matches && matches.length > 1) {
        return matches[1];
      }
    }
    return null;
  }
}

export { LoginRequest };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/login/_domain/requests/index.ts